import type { ExperiencePageTypeEnum } from "@/utils/enums/ExperiencePageTypeEnum";

import type { CategoryBanner } from "./ResponseCategoryTabs";

export interface ExperienceGetTypeInterface {
  status: boolean;

  message?: string;

  slugType: ExperiencePageTypeEnum;

  data: InfoPathSlug | null;
}

export interface InfoPathSlug {
  countryName: string;
  countrySlug: string;
  cityName: string;
  citySlug: string;
  teamName: string;
  teamNameEn: string;
  teamSlug: string;
  categoryName: string;
  categorySlug: string;
  subCategoryName: string;
  subCategoryNameEn: string;
  subCategorySlug: string;
  slug: string;
  latitude?: string;
  longitude?: string;
  banner?: CategoryBanner;
}

export class ResponseExperienceGetTypeInterface {
  readonly status: boolean = false;

  readonly message: string = "";

  readonly slugType: ExperiencePageTypeEnum | null = null;

  readonly data: InfoPathSlug | null = null;

  constructor(data: any) {
    this.status = data.status;
    this.message = data.message;
    this.slugType = data.slugType;
    this.data = data.data;
  }
}
